window.$ = window.jQuery = require('jquery');
require('bootstrap');
import 'slick-carousel'
function handerScroll() {
    const routeName = $("#txt-route-name").val()
    const navbar = document.querySelector('.elc-navbar')
    if (!navbar) {
        return
    }
    if (routeName === 'news.detail' || routeName === 'shareholder.show' || routeName === 'ai.activate' || !routeName) {
        navbar.classList.add('navbar-white')
        return
    }
    const width = window.innerWidth
    let topLimit = 70
    if (width <= 576) {
        topLimit = 10
    } else if (width <= 768) {
        topLimit = 50
    }
    const top = window.scrollY
    if (top > topLimit) {
        navbar.classList.add('navbar-white')
    } else {
        navbar.classList.remove('navbar-white')
    }
}
$(document).on('scroll', function (e) {
    handerScroll()
});
$(document).ready(function () {
    handerScroll()
})
const notify = function (type, message, title) {
    Swal.fire({
      position: 'center',
      icon: type,
      title: title,
      text: message,
      width: 495,
      height:246,
      size: 18,
      showConfirmButton: false,
      timer: 3000,
    })
}


window.notify = notify;